import Inaccessible from './Inaccessible'
import LinkToDocusaurus from '../LinkToDocusaurus'
import {
  Artwork,
  LinkButton,
  Paragraph
} from '@eggplant/pattern-library'
import { LinkToModelHub } from '@eggplant/routing'
import { daiLicenseAdmin } from '../../docs-routes'
import type { CSSProperties } from 'react'

const wrapperStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  padding: '120px 0',
  rowGap: '40px'
}

const FeatureInaccessible = () =>
  <div style={wrapperStyle}>
    <Artwork.Lock />
    <Inaccessible />
    <Paragraph>
      <LinkButton variant='secondary'>
        <LinkToModelHub>
          Back to home page
        </LinkToModelHub>
      </LinkButton>
    </Paragraph>
    <div>
      <LinkToDocusaurus path={daiLicenseAdmin}>
        Learn more in the DAI documentation
      </LinkToDocusaurus>
    </div>
  </div>

export default FeatureInaccessible
